import { FC } from "react";

import './Background.scss';


const Background: FC = () => {

	return (
		<svg width="1920" height="949" viewBox="0 0 1920 949" fill="none" xmlns="http://www.w3.org/2000/svg" className="Background">
			<g opacity="0.7">
				<path d="M752.607 289L1550.5 972.5L1491.71 1071.7L684.443 953.616L752.607 289Z" fill="url(#paint0_linear_18_714)" fillOpacity="0.6"/>
				<path d="M1265 1042L1790.5 77L2054.5 43V1008L1265 1042Z" fill="black"/>
				<g filter="url(#filter0_f_18_714)">
					<path d="M2071 1068.5C2071 1273.67 1904.67 1440 1699.5 1440C1494.33 1440 1030 1357.17 1030 1152C1590.5 813.5 1444.5 894.5 1807 291C2012.17 291 2071 863.326 2071 1068.5Z" fill="url(#paint1_radial_18_714)" fillOpacity="0.5"/>
				</g>
				<path d="M789.062 291L-8.83069 974.5L49.9563 1073.7L685 944.5L789.062 291Z" fill="url(#paint2_linear_18_714)" fillOpacity="0.6"/>
				<g filter="url(#filter1_f_18_714)">
					<circle cx="-152" cy="-26" r="287" fill="url(#paint3_radial_18_714)" fillOpacity="0.5"/>
				</g>
			</g>
			<defs>
				<filter id="filter0_f_18_714" x="430" y="-309" width="2241" height="2349" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix"/>
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
					<feGaussianBlur stdDeviation="300" result="effect1_foregroundBlur_18_714"/>
				</filter>
				<filter id="filter1_f_18_714" x="-1039" y="-913" width="1774" height="1774" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix"/>
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
					<feGaussianBlur stdDeviation="300" result="effect1_foregroundBlur_18_714"/>
				</filter>
				<linearGradient id="paint0_linear_18_714" x1="1109" y1="938" x2="871" y2="451" gradientUnits="userSpaceOnUse">
					<stop/>
					<stop offset="1" stopOpacity="0"/>
				</linearGradient>
				<radialGradient id="paint1_radial_18_714" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1699.5 1068.5) rotate(90) scale(371.5 371.5)">
					<stop stopColor="#FF8800"/>
					<stop offset="0.525" stopColor="#BD6400"/>
					<stop offset="1"/>
				</radialGradient>
				<linearGradient id="paint2_linear_18_714" x1="629" y1="923" x2="688.5" y2="500.5" gradientUnits="userSpaceOnUse">
					<stop/>
					<stop offset="1" stopOpacity="0"/>
				</linearGradient>
				<radialGradient id="paint3_radial_18_714" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-152 -26) rotate(90) scale(287)">
					<stop stopColor="#FF8800"/>
					<stop offset="0.525" stopColor="#BD6400"/>
					<stop offset="1"/>
				</radialGradient>
			</defs>
		</svg>
	)
}

export default Background;